import { render, staticRenderFns } from "./theme-mapping-modal.vue?vue&type=template&id=3c6a1eda"
import script from "./theme-mapping-modal.vue?vue&type=script&lang=js"
export * from "./theme-mapping-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports